/*
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-08-19 10:02:18
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:21:47
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/PrivacyCollect/mx/direct.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { memo, useEffect } from 'react';
import globalStyles from '../../../../global.less';
import styles from '../index.less';

var HTML_CONTENT = ""
HTML_CONTENT += `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Para entregar los productos que ordene en nuestra tienda a la dirección que designe, Xiaomi recopilará <strong>su nombre, número de teléfono y dirección de entrega</strong> tal como los proporcione aquí y los compartirá con nuestro proveedor de servicios de entrega que entregará los productos a usted.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">La base legal para este procesamiento de sus datos personales es que es <strong>necesario para llevar a cabo un contrato del que usted es parte.</strong></span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Puede ejercer sus derechos de protección de datos (por ejemplo, acceso, rectificación y/o supresión) a través de nuestra Plataforma de Soporte de Privacidad (<a href="https://privacy.mi.com/support/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff">https://privacy.mi.com/support/</span></a>).</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Puede encontrar más información sobre el procesamiento de sus datos personales haciendo referencia a nuestra Política de Privacidad (<a href="https://privacy.mi.com/all/languages/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff">https://privacy.mi.com/all/languages/</span></a>).</span>
                    </span>
                </p>
            </div>
        </body>
    </html>`;


function ProtocolPage() {

    useEffect(() => {
    }, []);

    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(ProtocolPage)